import React from 'react';
import Info from "./Info";

const CountTotal = ({img, label, count, unit, info}) => {
    return (
        <div className='count-total'>
            <div className='count-total__block'>{img}</div>
            <div className='count-total__block'><div>{label}{info && <Info name={label} text={info}/>}:</div></div>
            <div className='count-total__block'>{<b>{count} {unit}</b>}</div>
        </div>
    );
};

export default CountTotal;


// WEBPACK FOOTER //
// ./App/components/CountTotal.jsx